import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { postClose } from "@WahooFitness/wahoo-offline-mfe";

// Native appends ?drawer=true when it presents a route as a dismissible
// drawer/modal rather than pushing it. The "X" icon and the back-press/swipe
// gesture both need to resolve to the same close action in that case —
// otherwise the header shows a close affordance that a hardware back-press
// or swipe silently ignores in favor of plain SPA history navigation.
function useDrawerPresentation(viewId: string) {
  const [searchParams] = useSearchParams();
  const isDrawer = searchParams.get("drawer") === "true";
  const close = useCallback(() => postClose(viewId), [viewId]);
  return { isDrawer, close };
}

export default useDrawerPresentation;
